
export default [
  {
    path: '/mujia/login',
    name: 'mujiaLogin',
    component: resolve => require(['@/pages/mujia/Login'], resolve)
  },
  {
    path: '/mujia/order',
    name: 'mujiaOrder',
    component: resolve => require(['@/pages/mujia/Order'], resolve)
  },
  {
    path: '/mujia/scanResult',
    name: 'mujiaScanResult',
    component: resolve => require(['@/pages/mujia/ScanResult'], resolve)
  },
  {
    path: '/mujia/orderDetail/:id',
    name: 'mujiaOrderDetail',
    component: resolve => require(['@/pages/mujia/OrderDetail'], resolve)
  },
  {
    path: '/mujia/orderDetail1/:id',
    name: 'mujiaOrderDetail1',
    component: resolve => require(['@/pages/mujia/OrderDetail1'], resolve)
  },
  {
    path: '/mujia/scanQRCode',
    name: 'mujiaScanCode',
    component: resolve => require(['@/pages/mujia/ScanCode'], resolve)
  },
  {
    path: '/mujia/scanQREnter',
    name: 'mujiaScanQREnter',
    component: resolve => require(['@/pages/mujia/ScanEnter'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/mujia.js